module.exports = "<div ncy-breadcrumb></div> <h1 translate>FAQ</h1> <div class=r> <div class=\"c w-xl-2-3 w-xx-1-2\"> <div ng-repeat=\"help in ::vm.helpCategories\"> <div class=\"box box-2\"> <div class=box-bd> <div ng-repeat=\"subCategory in ::help.subCategories\"> <div class=folder-faq ng-repeat=\"question in subCategory.questions\"> <folder-collapse is-open=\"question.questionCode == vm.questionCode\" folder-title=question.question> <div class=richtext ng-bind-html=::question.answer> </div> </folder-collapse> </div> </div> </div> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/help/help.html
// module id = 596
// module chunks = 0